export default __webpack_public_path__ + "static/media/SVG2.74485fa3.svg";